import { User, UserAction, UserActions } from '../model';

export function login(email: string, password: string): UserAction {
  return {
    type: UserActions.LOGIN,
    payload: {
      request: {
        url: '/auth/login',
        method: 'POST',
        data: {
          email,
          password,
        },
      },
    },
  };
}

export const RefreshUrl = '/auth/refresh';

export function refresh(email: string, refreshToken: string): UserAction {
  return {
    type: UserActions.REFRESH_TOKEN,
    payload: {
      request: {
        url: RefreshUrl,
        method: 'POST',
        data: {
          refreshToken,
          email,
        },
      },
    },
  };
}

export function logout(): UserAction {
  return {
    type: UserActions.LOGOUT,
    payload: null,
  };
}

export function fetchAdmins(): UserAction {
  return {
    type: UserActions.FETCH_ADMINS,
    payload: {
      request: {
        url: '/users/admins',
        method: 'GET',
      },
    },
  };
}

export function createAdminUser(
  user: User
): UserAction {
  return {
    type: UserActions.CREATE_ADMIN_USER,
    payload: {
      request: {
        url: '/users/admins',
        method: 'POST',
        data: user,
      },
    },
  };
}

export function updateAdminUser(
  user: User,
  userId: number
): UserAction {
  return {
    type: UserActions.UPDATE_ADMIN_USER,
    payload: {
      request: {
        url: `/users/admins/${userId}`,
        method: 'PUT',
        data: user,
      },
    },
  }
}
